module.exports = __webpack_public_path__ + "static/media/HelveticaNeueCyr-Regular.176a4211.woff2";